import React from 'react';
import { useTexts, TXT } from '../../context/TextContext';

export default function ConfirmModal({ show, message, onConfirm, onCancel }) {
  const { t } = useTexts();
  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fa-solid fa-triangle-exclamation me-2 color1" />
              {t(TXT.CONFIRMATION, 'Confirmation')}
            </h5>
            <button type="button" className="btn-close" onClick={onCancel} />
          </div>

          <div className="modal-body" style={{ padding: '1.25rem 1.5rem', fontSize: '0.95rem' }}>
            {message}
          </div>

          <div className="modal-footer">
            <button className="button" onClick={onCancel}>
              <i className="fa-solid fa-xmark fa-1x" />
              &nbsp;{t(TXT.CANCEL, 'Cancel')}
            </button>
            <button className="button color1" onClick={onConfirm}>
              <i className="fa-solid fa-check fa-1x color1" />
              &nbsp;{t(TXT.CONFIRM, 'Confirm')}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
